<template>
  <div>
    <el-row>
      <h2>订单报表</h2>
    </el-row>

    <el-row>
      <div id="chart1" style="width: 100%; height: 500px"></div>
    </el-row>
    <!-- <el-row>
      <el-col :span="6">
        <el-card>
          <p>站点数：</p>
          <p>设备总数：</p>
          <p>网关总数：</p>
          <p>网关插座总数：</p>
          <p>独立设备总数：</p>
          <p>独立设备接口总数：</p>
        </el-card>
      </el-col>
    </el-row> -->
  </div>
</template>
<script>
import { apiListStations } from "../charge/charge-equipment";
import {
  apiStatistical,
  apiStatisticalReportData,
  apiStatisticalExport,
  apiStatisticalReportDailyData,
} from "./api";
export default {
  name: "ChargingOrderEcharts",
  date() {
    return {
      stationList: [],
      stationIdOptions: [],
      searchForm: {
        stationId: null,
        page: 1,
        size: 999,
      },
    };
  },
  created() {
    console.log("created");
    // this.initSelectStations();
  },
  mounted() {
    console.log("mounted");
    this.drawLine();
  },
  methods: {
    initSelectStations() {
      apiListStations({}).then((resp) => {
        if (resp.status == 200) {
          const data = resp.data;
          this.stationList = data.list;
          this.stationList.forEach((element) => {
            this.stationIdOptions.push({
              label: element.stationName,
              value: element.id,
            });
          });
        }
      });
    },
    stationIdChange(v) {
      console.log("U Selected " + v);
    },
    search() {},
    clearForm() {},
    drawLine() {
      console.log("=========================" + this.searchForm);
      if (this.searchForm == undefined) {
        this.searchForm = {};
      }
      apiStatisticalReportDailyData({}).then((resp) => {
        let data = resp.data.list;
        let _chart1 = this.$echarts.init(document.getElementById("chart1"));
        let xAxisData = new Array();
        let yOrders = new Array();
        let yMoney = new Array();
        let yTotalPower = new Array();
        let index = data.length - 1;
        data.forEach((e) => {
          xAxisData[index] = e.statisticalDate;
          yOrders[index] = e.totalOrders;
          yMoney[index] = e.totalMoney;
          yTotalPower[index] = e.totalPower;
          index--;
        });
        let option = {
          title: {
            text: "充电订单与充电电量、充电收入",
          },
          legend: {
            data: ["订单数", "充电电量", "充电收入"],
          },
          tooltip: {
            trigger: "axis",
          },
          xAxis: {
            type: "category",
            data: xAxisData,
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              name: "订单数",
              data: yOrders,
              type: "line",
            },
            {
              name: "充电电量",
              data: yTotalPower,
              type: "line",
            },
            {
              name: "充电收入",
              data: yMoney,
              type: "bar",
              color: "green",
            },
          ],
        };
        _chart1.setOption(option);
      });
    },
  },
};
</script>